import { useQuery, UseQueryOptions, useQueryClient } from "@tanstack/react-query";
import axios from "axios";

export interface MenuType {
  id: number;
  descricao: string;
  menuId?: number;
  routePath?: string;
  routePathName?: string;
  icon?: string;
  iconSet?: "font-awesome" | "feather" | "unicons";
  label?: boolean;
  subMenus: MenuType[];
}

export interface MenuApiResponse {
  data: MenuType[];
  isSuccess: boolean;
  message: string;
}

// Main hook - single query for all menus with complete hierarchy
export const useMenu = (options?: UseQueryOptions<MenuApiResponse>) => {
  return useQuery<MenuApiResponse>({
    queryKey: ["menus"],
    queryFn: async (): Promise<MenuApiResponse> => {
      const response = await axios.get<MenuApiResponse>("/api/menu");
      return response.data;
    },
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // 5 minutes - menus don't change frequently
    ...options
  });
};

// Hook para invalidar o cache de menus quando o grupo do usuário for atualizado
export const useInvalidateMenuCache = () => {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: ["menus"] });
};